
import { defineComponent } from "vue";

interface HTMLInputEvent extends Event {
  target: HTMLInputElement & EventTarget;
}

export default defineComponent({
  name: "my-textarea",
  props: {
    modelValue: String,
  },
  methods: {
    updateInput(e: HTMLInputEvent) {
      this.$emit("update:modelValue", e.target.value);
    },
  },
});
